module.exports = __webpack_public_path__ + "img/修改gld_gbt845_1985.prt.b83c027e.jpg";